export default __webpack_public_path__ + "static/media/tileafter.5a65a27a.jpg";